import * as Types from "./type";
export const categoryAction = (value) => {
  return {
    type: Types.ARTICLESET,
    payload: value,
  };
};
export const adminAction = (value) => {
  return {
    type: Types.ADMINSET,
    payload: value,
  };
};
export const resetAllDataAction = (value) => {
  return {
    type: Types.RESETALL,
  };
};
